// TODO: Deprecate TrackingEntry type
export type TrackingEntry = {
  _keyValuePairs: { [key: string]: string };
};

// Base set of tracking cookie parameter keys
export const TrackingCookieKeys = [
  "ad_id",
  "customer_id",
  "dclid",
  "fbclid",
  "gad_source",
  "gclid",
  "gclsrc",
  "gbraid",
  "http_referer",
  "iad-adgroup-id",
  "iad-campaign-id",
  "iad-keyword-id",
  "li_fat_id",
  "matchtype",
  "msclkid",
  "sccid",
  "segmentanonymousid",
  "timestamp",
  "ttclid",
  "twclid",
  "utm_adgroup",
  "utm_campaign",
  "utm_content",
  "utm_creative",
  "utm_medium",
  "utm_source",
  "utm_term",
  "wbraid",
  "wt.mc_id",
  "wt.tsrc",
] as const;

export type TrackingCookieKey = (typeof TrackingCookieKeys)[number];

// Note that TrackingCookie is an array of TrackingData objects in the API.
export type TrackingCookie = Partial<Record<TrackingCookieKey, string>>;

// The API expects an array of TrackingEntry objects for attribution.
// ex:
// [
//   {"_keyValuePairs":{"timestamp":"2023-11-17 21:04:37.762","gclid":"123456"}},
//   {"_keyValuePairs":{"timestamp":"2023-11-17 21:04:40.935","gclid":"1234567"}},
//   {"_keyValuePairs":{"timestamp":"2023-11-17 21:04:45.085","gclid":"ServCheckOne"}}
// ]
export type TrackingData = {
  _keyValuePairs: Record<string, string>;
};

export function formatTrackingCookieForAttribution(
  trackingCookieArray: TrackingCookie[],
): TrackingData[] {
  return trackingCookieArray.map((cookie) => {
    const keyValuePairs: Record<string, string> = {};
    for (const key in cookie) {
      if (
        Object.hasOwn(cookie, key) &&
        cookie[key as TrackingCookieKey] !== undefined
      ) {
        keyValuePairs[key] = cookie[key as TrackingCookieKey]!;
      }
    }
    return { _keyValuePairs: keyValuePairs };
  });
}
